/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_TitelInputs */

const nl_planning_vakanties_titel = /** @type {(inputs: Planning_Vakanties_TitelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vakanties en vrije dagen`)
};

/**

* @param {Planning_Vakanties_TitelInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_titel = /** @type {((inputs?: Planning_Vakanties_TitelInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_TitelInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_titel(inputs)
});
export { planning_vakanties_titel as "planning.vakanties.titel" }